import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Modal, ModalBody, ModalHeader, FormGroup, Label, Button } from 'reactstrap';

import StandardIcon from '../../../assets/standard-method.png'
import UniqueIcon from '../../../assets/unique-method.png'

const Step5FindMatchesSetup = ({ onSelectMethod }) => {
  const { watch, setValue } = useFormContext();
  const [standardModalOpen, setStandardModalOpen] = useState(false);
  const [removePreviousMatching, setRemovePreviousMatching] = useState(false);
  const [removeExistingNextToBrandsCompetitors, setRemoveExistingNextToBrandsCompetitors] = useState(false);

  const openStandardModal = () => {
    setRemovePreviousMatching(!!watch('find_matches.remove_previous_matching'));
    setRemoveExistingNextToBrandsCompetitors(!!watch('brand_info.remove_existing_next_to_brands_competitors'));
    setStandardModalOpen(true);
  };

  const closeStandardModal = () => {
    setStandardModalOpen(false);
  };

  const handleStandardContinue = () => {
    setValue('find_matches.remove_previous_matching', removePreviousMatching, {
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue('brand_info.remove_existing_next_to_brands_competitors', removeExistingNextToBrandsCompetitors, {
      shouldDirty: true,
      shouldValidate: true,
    });
    closeStandardModal();
    onSelectMethod('standard');
  };

  return (
    <div style={{
      maxWidth: '808px',
      width: '100%',
      background: '#fff',
      borderRadius: '10px',
      padding: '32px 36px',
    }}>
      <h5 style={{ fontWeight: '600', fontSize: '18px', marginBottom: '4px' }}>
        Do you want to find matches as well for this brand?
      </h5>
      <p style={{ color: '#888', fontSize: '13px', marginBottom: '32px' }}>
        Select one method to find matches for this brand
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        {/* Standard Method Card */}
        <div style={methodCardStyle}>
          <div style={iconWrapperStyle}>
            <img src={StandardIcon} alt="Standard Method" style={{ width: '30px', height: '40px' }} />
          </div>
          <h6 style={methodTitleStyle}>Standard Method</h6>
          <p style={methodDescStyle}>
            HyperScout AI will create profile and find best retailer matches using your provided inputs
          </p>
          <button
            type="button"
            onClick={openStandardModal}
            style={selectBtnStyle}
          >
            Select Standard Method
          </button>
        </div>

        {/* Unique Method Card */}
        <div style={methodCardStyle}>
          <div style={iconWrapperStyle}>
            <img src={UniqueIcon} alt="Unique Method" style={{ width: '40px', height: '40px' }} />
          </div>
          <h6 style={methodTitleStyle}>Unique Method</h6>
          <p style={methodDescStyle}>
            Choose a structured request type for matching
          </p>
          <button
            type="button"
            onClick={() => onSelectMethod('unique')}
            style={selectBtnStyle}
          >
            Select Unique Method
          </button>
        </div>
      </div>

      <Modal isOpen={standardModalOpen} toggle={closeStandardModal} centered>
        <ModalHeader toggle={closeStandardModal}>Standard method</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label style={modalLabelStyle}>
              Previous Matching <span style={{ color: '#e53' }}>*</span>
            </Label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingTop: '4px' }}>
              <label style={checkboxLabelStyle}>
                <input
                  type="checkbox"
                  checked={removePreviousMatching}
                  onChange={(e) => setRemovePreviousMatching(e.target.checked)}
                  style={{ marginRight: '8px', width: '16px', height: '16px' }}
                />
                Remove Previous matching
              </label>
            </div>
          </FormGroup>
          <FormGroup>
            <Label style={modalLabelStyle}>
              Next To Brands &amp; Competitors
            </Label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingTop: '4px' }}>
              <label style={checkboxLabelStyle}>
                <input
                  type="checkbox"
                  checked={removeExistingNextToBrandsCompetitors}
                  onChange={(e) => setRemoveExistingNextToBrandsCompetitors(e.target.checked)}
                  style={{ marginRight: '8px', width: '16px', height: '16px' }}
                />
                Removing existing next to brands &amp; competitors
              </label>
            </div>
          </FormGroup>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px' }}>
            <Button type="button" color="outline" onClick={closeStandardModal}>
              Cancel
            </Button>
            <Button type="button" color="dark" onClick={handleStandardContinue}>
              Continue
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

const modalLabelStyle = {
  fontSize: '13px',
  fontWeight: '500',
  color: '#333',
  marginBottom: '6px',
};

const checkboxLabelStyle = {
  fontSize: '13px',
  color: '#333',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  margin: 0,
};

const methodCardStyle = {
  background: '#fff',
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  padding: '24px 20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textAlign: 'left',
};

const iconWrapperStyle = {
  marginBottom: '16px',
};

const methodTitleStyle = {
  fontSize: '16px',
  fontWeight: '600',
  color: '#222',
  marginBottom: '8px',
};

const methodDescStyle = {
  fontSize: '13px',
  color: '#888',
  lineHeight: '1.5',
  marginBottom: '20px',
  minHeight: '60px',
};

const selectBtnStyle = {
  width: '100%',
  background: '#222',
  border: 'none',
  color: '#fff',
  fontSize: '13px',
  fontWeight: '500',
  padding: '10px 20px',
  borderRadius: '6px',
  cursor: 'pointer',
  transition: 'background 0.2s',
};

export default Step5FindMatchesSetup;
